<template>
  <div class="title-bar">
    <div v-for="item in shapeEntries" :key="item.key" class="title-card">
      <div class="locker-type-title">
        {{ item.key }}
      </div>
      <div class="locker-type-count">
        {{ item.available }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lockerSizeCounter: Object
  },
  data () {
    return {
      keyTitleMap: Object.keys(this.lockerSizeCounter)
    }
  },
  computed: {
    shapeEntries () {
      return Object.entries(this.lockerSizeCounter).map(([key, val]) => ({
        key,
        total: Number(val?.total || 0),
        available: Number(val?.available || 0)
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: left;
  gap: 28px;
  & > div {
    max-width: calc(((100% - 84px) / 4) - 34px);
    width: 100%;
    text-align: left;
    border: 1px solid $borderDark1;
    border-radius: 8px;
    padding: 16px 16px;
    .locker-type-title {
      font-size: 15px;
      font-weight: bold;
      color: $subFontColor;
    }
    .locker-type-count {
      font-size: 25px;
      font-weight: bold;
      margin-top: 12px;
      color: $mainFontColor;
    }
  }
}
</style>
